<template>
  <Block class="course-outline-assessment this-block" lift>
    <div slot="header" class="-header">
      <div class="--title">
        <span>หลักเกณฑ์การประเมิน</span>
        <span> คะแนนเต็ม {{ assesmentSum }}</span>
      </div>
      <div class="--controllers">
        <vx-tooltip text="Add">
          <vs-button
            class="controller-buttons" radius color="gray" type="gradient" icon="plus_one"
            @click="
              $emit('call-editor', 'edit-assessment', {
                mode: 'add', data: { courseOutlineId }
              })
            "
          />
        </vx-tooltip>

        <vx-tooltip text="Refresh">
          <vs-button
            class="controller-buttons"
            radius
            color="grey"
            type="gradient"
            icon="autorenew"
            @click="reloadData"
          />
        </vx-tooltip>
      </div>
    </div>

    <div>
      <vs-table :data="assessments" v-if="assessments">
        <template slot="header">
          <div class="table-header"></div>
        </template>

        <template slot="thead" v-for="(thead, indexth) in table.header">
          <vs-th :key="indexth">
            {{ thead.title }}
          </vs-th>
        </template>

        <template slot-scope="{data}" class="table-body">
          <vs-tr
            class="-rows"
            :data="{ data: tr, index: indextr }"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td :data="indextr">
              {{ tr.assessment.nameLocal }}
            </vs-td>

            <vs-td>
              <div class="row-controller">
                <vx-tooltip text="Edit">
                  <vs-button
                    radius
                    color="gray"
                    type="gradient"
                    icon="edit"
                    @click="
                      $emit('call-editor', 'edit-assessment', {
                        data: tr, mode: 'edit', courseOutlineId
                      })
                    "
                  />
                </vx-tooltip>

                <vx-tooltip text="Delete">
                  <vs-button
                    radius
                    color="grey"
                    type="gradient"
                    icon="delete"
                    size="small"
                    @click="deleteRow(tr)"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
            
            <vs-td :data="indextr">
              {{ tr.percent }} %
            </vs-td>

            <vs-td :data="indextr">
              {{ tr.score }}
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </Block>
</template>

<script>
import { Block } from "@/components/common-ui";
import { deleteCourseOutlineAssessmentById } from "@/services/api/course-outline";

export default {
  components: {
    Block
  },
  props: {
    assessments: Array,
    courseOutlineId: String,
    methods: Object,
  },
  data() {
    return {
      table: {
        header: [
          {
            "key": "assessment.nameLocal",
            "title": "หลักเกณฑ์"
          },
          {
            "key": "actions",
            "title": ""
          },
          {
            "key": "percent",
            "title": "เปอร์เซ็นต์"
          },
          {
            "key": "score",
            "title": "คะแนน"
          }
        ]
      }
    }
  },
  computed: {
    assesmentSum() {
      if (Array.isArray(this.assessments)) {
        return this.assessments.reduce((prev, curr) => {
          return prev + (curr.score || 0);
        }, 0);
      } return [];
    }
  },
  methods: {
    reloadData() {
      if (this.methods) {
        if (Object.prototype.hasOwnProperty.call(this.methods, 'reloadData')) {
          this.methods.reloadData();
        }
      }
    },
    async deleteRow(row) {
      const { id } = row;
      if (id) {
        await deleteCourseOutlineAssessmentById(id);
        this.methods.reloadData();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'common-scoped';

.this-block {
}

#instruction-text{
  flex-grow: 3;
  & > span {
    font-size: 0.9rem;
  }
}

#instruction-video {
  flex-grow: 1;
  & > span {
    font-size: 0.9rem;
    color: red;
  }
}

.-rows {
  & .row-controller {
    display: inline-flex;

    & button {
      margin: 2px;
      color: #555;
      border: 2px solid #ddd;
      background: #eee;
      width: 20px !important;
      height: 20px !important;
      padding: 0;

      &:hover {
        color: #ddd;
        border: 2px solid #555;
        background: #333;
      }
    }
  }
}

</style>
